import Alpine from 'alpinejs'
Alpine.data('navigation', () => ({
    isOpen: false,
    toggle() {
        this.isOpen = !this.isOpen
    },
    close() {
        this.isOpen = false
    },
    open() {
        this.isOpen = true
    }
}))
